import { FunctionComponent, PointerEvent } from 'react';
import { Box } from '@chakra-ui/react';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

type DragHandleProps = {
  isDisabled?: boolean;
  /** Dispara o drag do framer-motion. Necessário pra Reorder.Item funcionar
   *  só através da handle (e não pelo item inteiro). */
  onPointerDown?: (event: PointerEvent) => void;
  'aria-label': string;
};

/**
 * Alça visual + capturadora do pointer-down para integração com `useDragControls`
 * do framer-motion. `touchAction: 'none'` é obrigatório pra funcionar em touch.
 */
export const DragHandle: FunctionComponent<DragHandleProps> = ({
  isDisabled,
  onPointerDown,
  ...rest
}) => (
  <Box
    role="button"
    aria-label={rest['aria-label']}
    cursor={isDisabled ? 'not-allowed' : 'grab'}
    color={isDisabled ? 'gray.300' : 'gray.400'}
    _hover={{ color: isDisabled ? 'gray.300' : 'brand.500' }}
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    w="24px"
    h="24px"
    style={{ touchAction: 'none' }}
    onPointerDown={(event) => {
      if (isDisabled || !onPointerDown) return;
      onPointerDown(event);
    }}
  >
    <ChakraFeatherIcon name="menu" boxSize="16px" />
  </Box>
);
